import React, { useState } from 'react';
import IconArrowRight from '@nxsys/components/AppIconSvg/IconArrowRight';
import clsx from 'clsx';

type ReportItemProps = {
  title: string;
  onClick: () => void;
  className?: string;
};

const ReportItem: React.FC<ReportItemProps> = ({
  title,
  onClick,
  className,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={clsx(
        'ReportItem rounded-lg px-4 py-3 cursor-pointer flex items-center justify-between transition-all duration-200',
        className,
      )}
      style={{
        background: isHovered
          ? 'linear-gradient(278.36deg, #00CA98 47.11%, #079A76 97.82%)'
          : '#F3F4F8',
      }}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span
        className={clsx(
          'text-sm font-medium leading-normal',
          isHovered ? 'text-white' : 'text-neutral-900',
        )}
      >
        {title}
      </span>
      <IconArrowRight
        width={18}
        height={14}
        color={isHovered ? '#FFFFFF' : undefined}
      />
    </div>
  );
};

export default ReportItem;
